// Central data-testid registry.
export const AUTH = {
  loginGoogleButton: "login-google-button",       // legacy admin login (still used)
  memberGoogleButton: "member-google-button",
  memberPhoneButton: "member-phone-button",
  memberTelegramButton: "member-telegram-button",
  logoutButton: "logout-button",
  authCallback: "auth-callback-processing",
};

export const NAV = {
  sidebar: "admin-sidebar",
  linkQueue: "nav-queue",
  linkVenues: "nav-venues",
  linkLeads: "nav-leads",
  linkPublished: "nav-published",
  linkSettings: "nav-settings",
  linkUsers: "nav-users",
  linkSources: "nav-sources",
  linkSubmit: "nav-submit",
  linkPreview: "nav-preview",
};

export const QUEUE = {
  list: "queue-list",
  item: (id) => `queue-item-${id}`,
  reviewer: "queue-reviewer",
  fieldTitle: "field-title",
  fieldStartAt: "field-start-at",
  fieldEndAt: "field-end-at",
  fieldVenueDisplay: "field-venue-display",
  fieldVenuePicker: "venue-picker-input",
  fieldPrice: "field-price",
  fieldDescription: "field-description",
  fieldOrganiser: "field-organiser",
  fieldCover: "field-cover",
  ikoSelector: (cat) => `iko-selector-${cat}`,
  wordCount: "description-word-count",
  approveButton: "approve-publish-button",
  rejectButton: "reject-button",
  saveButton: "save-draft-button",
  mergeButton: "merge-dedupe-button",
  ingestText: "ingest-text-button",
  ingestImage: "ingest-image-button",
  ingestTextInput: "ingest-text-input",
  ingestImageInput: "ingest-image-input",
};

export const VENUE = {
  addButton: "venue-add-button",
  nameInput: "venue-name-input",
  aliasesInput: "venue-aliases-input",
  areaInput: "venue-area-input",
  saveButton: "venue-save-button",
  row: (id) => `venue-row-${id}`,
};

export const LEAD = {
  row: (id) => `lead-row-${id}`,
  statusSelect: (id) => `lead-status-${id}`,
  notesInput: (id) => `lead-notes-${id}`,
};

export const PUBLISHED = {
  card: (id) => `published-card-${id}`,
  unpublishButton: (id) => `published-unpublish-${id}`,
  search: "published-search",
};

export const SETTINGS = {
  allowlistInput: "settings-allowlist",
  seedUrlsInput: "settings-seed-urls",
  thresholdInput: "settings-threshold",
  saveButton: "settings-save",
  runCrawlButton: "settings-run-crawl",
  embedSnippet: "settings-embed-snippet",
};

export const USERS = {
  search: "users-search",
  row: (id) => `users-row-${id}`,
  toggleEntitlement: (id, key) => `users-toggle-${id}-${key}`,
  toggleAdmin: (id) => `users-toggle-admin-${id}`,
};

export const SUBMIT = {
  form: "submit-form",
  titleInput: "submit-title",
  ikoSelector: (k) => `submit-iko-${k}`,
  dateInput: "submit-date",
  startTimeInput: "submit-start-time",
  endTimeInput: "submit-end-time",
  venueNameInput: "submit-venue-name",
  locationInput: "submit-location",
  freeToggle: "submit-free-toggle",
  priceAmountInput: "submit-price-amount",
  priceCurrencyInput: "submit-price-currency",
  descriptionInput: "submit-description",
  ticketLinkInput: "submit-ticket-link",
  imageInput: "submit-image",
  submitButton: "submit-button",
};

export const LANDING = {
  loginLink: "landing-login-link",
  discoveryLink: "landing-discovery-link",
  submitLink: "landing-submit-link",
};

export const DISCOVERY = {
  filter: (k) => `discovery-filter-${k}`,
  card: (id) => `discovery-card-${id}`,
};

export const HOME = { emergentLink: "emergent-link" };
